
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24 13c0 5.52-4.49 10-10 10l-.28-.004C8.33 22.848 4 18.426 4 13 4 7.49 8.48 3 14 3c5.51 0 10 4.49 10 10zM12.02 9c-.29.3-.29.77.01 1.06L14.98 13l-2.95 2.94c-.3.29-.3.77-.01 1.06.3.3.77.3 1.06 0l3.49-3.47a.75.75 0 000-1.06L13.08 9a.704.704 0 00-.52-.22c-.2 0-.39.07-.54.22z","fill":"var(--primary)"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d","x":"-2","y":"-2","width":"32","height":"32","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"1"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.909804 0 0 0 0 0.607843 0 0 0 0 0.0705882 0 0 0 0.3 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow","result":"shape"}})])])])
          )
        }
      }
    